import { defineNuxtPlugin } from 'nuxt/app';
import { createVuetify } from 'vuetify';
import colors from 'vuetify/util/colors';

import * as components from 'vuetify/components';

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({   
    theme: {
      themes: {
        light: {
          dark: false,
          colors: {
            primary: "#00012d",
            primaryOverlay: "#00304991",
            secondary: "#f9ae56",
            background: "#FCF6F5",
            alternatingBackground: "#b3b3b3",
          },
          variables: {
            primary: "#00012d",
            secondary: "#f9ae56",
            background: "#FCF6F5"
          }
        },
      },
    },  

    components,
    ssr: true
  });

  nuxtApp.vueApp.use(vuetify);
});